<div class="my-remax-menu has-pos-abs is-flex has-flex-content-center is-flex-column text-center" [ngClass]="ListingCategory[listingCategory]">
  <header>
    <img *ngIf="!currentUser.name" src="{{(listingCategory===ListingCategory.LUXURY?'/assets/icons/my-account/my-account-golden@1x.svg':'/assets/icons/my-account/my-account@1x.svg') | staticp}}" alt="{{ 'my-account.my-account' | translate }}">
    <app-circle-initials *ngIf="currentUser.name" [initials]="currentUser.getInitials()"></app-circle-initials>
    <div class="my-account">
      {{ 'my-account.my-account' | translate }}
    </div>
  </header>
  <ul class="nav site-links">
    <li role="presentation">
      <a title="{{ 'side-nav.saved-listings' | translate }}" [routerLink]="['/my-remax']" [queryParams]="{mode: MyRemaxModes.FAVOURITES}"
         angulartics2On="click" [angularticsProperties]="'_gotomysavedlistings' | listingTypeAnalyticsTag | async"
      >
        <span>
          {{ 'side-nav.saved-listings' | translate }}
        </span>
        <i class="material-icons">
          chevron_right
        </i>
      </a>
    </li>
    <li role="presentation">
      <a title="{{ 'side-nav.saved-searches' | translate }}" [routerLink]="['/my-remax']" [queryParams]="{mode: MyRemaxModes.SAVED_SEARCHES}"
        angulartics2On="click" [angularticsProperties]="'_goto_saved_searches' | listingTypeAnalyticsTag | async"
      >
        <span translate="side-nav.saved-searches"></span>
        <i class="material-icons">
          chevron_right
        </i>
      </a>
    </li>
    <li role="presentation">
      <a *appShowAuthed="true" title="{{ 'side-nav.account-details' | translate }}" [routerLink]="['account-details']">
        <span translate="side-nav.account-details"></span>
        <i class="material-icons">
          chevron_right
        </i>
      </a>
    </li>
    <ng-container *appShowAuthed="true">
      <li role="presentation" *ngIf="favouriteAgentUrl">
        <a title="{{ 'side-nav.favourite-agent' | translate }}" [routerLink]="favouriteAgentUrl">
          <span translate="side-nav.favourite-agent"></span>
          <i class="material-icons">chevron_right</i>
        </a>
      </li>
    </ng-container>
  </ul>
  <div class="register">
    <ng-container *appShowAuthed="false">
      <div class="view-it">
        {{ 'registration.view-it' | translate }}
      </div>
      <button class="btn login" [class.btn-polar-gradient]="ListingCategory.LUXURY !==listingCategory" [class.btn-luxury]="ListingCategory.LUXURY===listingCategory"
        [routerLink]="['/', { outlets: { popup: 'register-login'} }]">
        <span>
          {{ 'my-remax.saved-searches.register-login' | translate }}
        </span>
      </button>
    </ng-container>
    <button class="btn logout" *appShowAuthed="true" (click)="logout()">
      {{ 'registration.log-out' | translate }}
    </button>
  </div>
</div>
